import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutGalleryOverview = {
  factory: EElement({
    id: '2aab66f6-71ec-3941-852a-8aabdcd3863f',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('45cdfa28-6c3f-dc79-0e1e-414f9d8403f2')]),
      children: EList([
        EElement({
          id: '908236a5-5135-73e8-d9f2-1736e90b66aa',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: '6a533f60-2e20-840c-fbc9-8b238127c476',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('916ee694-47ba-1d95-3e1c-70b5cf389d87'),
                  ]),
                  children: EList([
                    EElement({
                      id: 'afe870de-ea26-273d-e428-58df9ff9477b',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        style: ERecord({
                          base: ERecord({
                            main: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                            medium: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 2'),
                                gridColumnEnd: EText('span 2'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                            tiny: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                          }),
                        }),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('2a055616-17e9-1965-216d-9af04ac75fca'),
                        ]),
                        children: EList([
                          EElement({
                            id: '4954481b-ff3f-cb3f-5345-dd5628ba1167',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Heading')
                            ),
                            data: ERecord({
                              tag: EEnum('h3'),
                              children: EList([
                                EElement({
                                  id: 'af54d902-1902-15d3-904c-58a2a8bcd6da',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Gallery section'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '24a0fa3e-2127-d26b-e2cc-344f0e7a7f95',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Paragraph')
                            ),
                            data: ERecord({
                              children: EList([
                                EElement({
                                  id: '24a0fa3e-2127-d26b-e2cc-344f0e7a7f96',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '2a7456f7-c87a-4a2c-d666-1f4ea705260f',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Block')
                            ),
                            data: ERecord({
                              tag: EEnum('div'),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('13df32e2-110d-7734-b474-4f43359e30bc'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '90f54c20-03b3-6867-1c38-48a2bc6b77f0',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('List')
                                  ),
                                  data: ERecord({
                                    tag: EEnum('ul'),
                                    list: ERecord({
                                      type: EText('list'),
                                      unstyled: EBoolean(true),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        'f41c19ca-f17f-ac61-d279-d3f563fa5f77'
                                      ),
                                    ]),
                                    children: EList([
                                      EElement({
                                        id: '90f54c20-03b3-6867-1c38-48a2bc6b77f1',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('ListItem')
                                        ),
                                        data: ERecord({
                                          list: ERecord({
                                            type: EText('item'),
                                          }),
                                          text: EBoolean(false),
                                          children: EList([
                                            EElement({
                                              id: '860c7c88-4a9a-59d2-f064-4cbdaa43c653',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Block')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('div'),
                                                text: EBoolean(true),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '7d679b38-3fb8-c614-0c1b-de6de1e2ffa1'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '860c7c88-4a9a-59d2-f064-4cbdaa43c654',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      'Etiam sodales ac felis id interdum'
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '90f54c20-03b3-6867-1c38-48a2bc6b77f2',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('ListItem')
                                        ),
                                        data: ERecord({
                                          list: ERecord({
                                            type: EText('item'),
                                          }),
                                          text: EBoolean(false),
                                          children: EList([
                                            EElement({
                                              id: '5565842f-ca37-f413-8872-c53ab3c3c77d',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Block')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('div'),
                                                text: EBoolean(true),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '7d679b38-3fb8-c614-0c1b-de6de1e2ffa1'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '5565842f-ca37-f413-8872-c53ab3c3c77e',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      'Etiam sodales ac felis id interdum'
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                      EElement({
                                        id: '90f54c20-03b3-6867-1c38-48a2bc6b77f3',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('ListItem')
                                        ),
                                        data: ERecord({
                                          list: ERecord({
                                            type: EText('item'),
                                          }),
                                          text: EBoolean(false),
                                          children: EList([
                                            EElement({
                                              id: '1ab5fbe3-682c-dd15-6963-4a6cc082477d',
                                              type: qualify(
                                                Plugins.name('Basic'),
                                                Component.name('Block')
                                              ),
                                              data: ERecord({
                                                tag: EEnum('div'),
                                                text: EBoolean(true),
                                                styleBlockIds: EList([
                                                  EText(
                                                    '7d679b38-3fb8-c614-0c1b-de6de1e2ffa1'
                                                  ),
                                                ]),
                                                children: EList([
                                                  EElement({
                                                    id: '1ab5fbe3-682c-dd15-6963-4a6cc082477e',
                                                    type: qualify(
                                                      Plugins.name('Basic'),
                                                      Component.name('String')
                                                    ),
                                                    data: EText(
                                                      'Etiam sodales ac felis id interdum'
                                                    ),
                                                  }),
                                                ]),
                                              }),
                                            }),
                                          ]),
                                        }),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '7a437b89-d075-380c-9b0c-7c5015798b8b',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(true),
                              eventIds: EList([]),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              block: EText(''),
                              styleBlockIds: EList([
                                EText('5811e2db-f107-fb36-bedc-ae019c696e30'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '7a437b89-d075-380c-9b0c-7c5015798b8c',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Get a demo'),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '00d87075-1900-a53d-27e7-7cfa977585be',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        style: ERecord({
                          base: ERecord({
                            main: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                          }),
                        }),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('0aedf519-3b74-1865-e2e4-926f45382757'),
                        ]),
                        children: EList([
                          EElement({
                            id: '5a32393f-07a0-9fda-0160-53a07770ee26',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageSun),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"6272c97c9356544785478f96"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('8ce3839e-2a35-149b-8c70-921387a656ed'),
                                EText('89b50107-cd85-1ac0-949b-4d4b42a224f4'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: '079839f2-df1a-d8aa-d044-75ec555c6842',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageHills),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"6272c97c9356544785478f91"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('8ce3839e-2a35-149b-8c70-921387a656ed'),
                                EText('89b50107-cd85-1ac0-949b-4d4b42a224f4'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: 'c2607b6f-0788-a01b-712c-d2a0ce3cfca0',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageGallery),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"6272c97c9356544785478f94"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('8ce3839e-2a35-149b-8c70-921387a656ed'),
                                EText('89b50107-cd85-1ac0-949b-4d4b42a224f4'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: '9c95cc8a-d597-46c2-7cf4-640fb644fdfc',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageSun),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"6272c97c9356544785478fa2"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('8ce3839e-2a35-149b-8c70-921387a656ed'),
                                EText('89b50107-cd85-1ac0-949b-4d4b42a224f4'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: 'd9b24d49-7611-9217-cbff-300f627ba9c0',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        style: ERecord({
                          base: ERecord({
                            main: ERecord({
                              noPseudo: ERecord({
                                gridColumnStart: EText('span 1'),
                                gridColumnEnd: EText('span 1'),
                                gridRowStart: EText('span 1'),
                                gridRowEnd: EText('span 1'),
                              }),
                            }),
                          }),
                        }),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('0aedf519-3b74-1865-e2e4-926f45382757'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'd9b24d49-7611-9217-cbff-300f627ba9c2',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageMountains),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"6272c97c9356544785478fb9"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('8ce3839e-2a35-149b-8c70-921387a656ed'),
                                EText('89b50107-cd85-1ac0-949b-4d4b42a224f4'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: 'd9b24d49-7611-9217-cbff-300f627ba9c1',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageOverlap),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"6272c97c9356544785478fb0"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('8ce3839e-2a35-149b-8c70-921387a656ed'),
                                EText('89b50107-cd85-1ac0-949b-4d4b42a224f4'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: '41c35b2e-ea29-5e69-39c1-eb7e8444b5d3',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageSun),
                                loading: EEnum('lazy'),
                                width: EText('652.5'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"6272c97c9356544785478fa2"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('8ce3839e-2a35-149b-8c70-921387a656ed'),
                                EText('89b50107-cd85-1ac0-949b-4d4b42a224f4'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                          EElement({
                            id: '80a2286c-e602-8c64-d9da-a9d6a03c492f',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Image')
                            ),
                            data: ERecord({
                              attr: ERecord({
                                src: EText(images.placeholderImageCards),
                                loading: EEnum('lazy'),
                                width: EText('auto'),
                                height: EText('auto'),
                                alt: EText('__wf_reserved_inherit'),
                              }),
                              style: ERecord({
                                base: ERecord({
                                  main: ERecord({
                                    noPseudo: ERecord({
                                      gridColumnStart: EText('span 1'),
                                      gridColumnEnd: EText('span 1'),
                                      gridRowStart: EText('span 1'),
                                      gridRowEnd: EText('span 1'),
                                    }),
                                  }),
                                }),
                              }),
                              img: ELiteral({
                                name: qualify(
                                  Plugins.name('Asset'),
                                  typeName('Image')
                                ),
                                value: JSON.parse(
                                  '{"id":"6272c97c9356544785478f8c"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('8ce3839e-2a35-149b-8c70-921387a656ed'),
                                EText('89b50107-cd85-1ac0-949b-4d4b42a224f4'),
                              ]),
                              temp: ERecord({
                                img: ERecord({
                                  src: EText(''),
                                }),
                              }),
                              srcsetDisabled: EBoolean(false),
                              sizes: EList([]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: '45cdfa28-6c3f-dc79-0e1e-414f9d8403f2',
      type: 'class',
      name: 'Gallery Overview',
      comb: '',
      styleLess:
        'position: relative; padding-top: 80px; padding-right: 30px; padding-bottom: 80px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00); background-color: hsla(216, 33.33%, 97.06%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: '916ee694-47ba-1d95-3e1c-70b5cf389d87',
      type: 'class',
      name: 'Gallery Wrapper',
      comb: '',
      styleLess:
        'display: grid; align-items: start; grid-auto-columns: 1fr; grid-column-gap: 40px; grid-row-gap: 40px; grid-template-columns: 1fr 1fr 1fr; grid-template-rows: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'grid-template-columns: 1fr 1fr;'},
        tiny: {styleLess: 'grid-template-columns: 1fr;'},
      },
    },
    {
      _id: '2a055616-17e9-1965-216d-9af04ac75fca',
      type: 'class',
      name: 'Gallery Block',
      comb: '',
      styleLess:
        'display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;',
      children: [],
      variants: {},
    },
    {
      _id: '13df32e2-110d-7734-b474-4f43359e30bc',
      type: 'class',
      name: 'Gallery Features Block',
      comb: '',
      styleLess: 'margin-top: 16px; margin-bottom: 24px;',
      children: [],
      variants: {},
    },
    {
      _id: 'f41c19ca-f17f-ac61-d279-d3f563fa5f77',
      type: 'class',
      name: 'Gallery List',
      comb: '',
      styleLess: '',
      children: [],
      variants: {},
    },
    {
      _id: '7d679b38-3fb8-c614-0c1b-de6de1e2ffa1',
      type: 'class',
      name: 'Gallery Feature',
      comb: '',
      styleLess: `margin-bottom: 8px; padding-left: 30px; background-image: url(${images.checkCircleDark}); background-position: 0% 50%; background-size: 20px; background-repeat: no-repeat; font-size: 14px; line-height: 24px;`,
      children: [],
      variants: {},
    },
    {
      _id: '5811e2db-f107-fb36-bedc-ae019c696e30',
      type: 'class',
      name: 'Button Primary',
      comb: '',
      styleLess:
        'padding-top: 12px; padding-right: 25px; padding-bottom: 12px; padding-left: 25px; background-color: #1a1b1f; transition-property: all; transition-duration: 200ms; transition-timing-function: ease; color: hsla(0, 0.00%, 100.00%, 1.00); font-size: 12px; line-height: 20px; letter-spacing: 2px; text-transform: uppercase;',
      children: [
        '7a50e611-1678-13fa-5f6c-0c95173beacf',
        '0333fb64-65a4-0eb3-2546-375483e0a446',
      ],
      variants: {
        main_hover: {
          styleLess:
            'background-color: #32343a; color: hsla(0, 0.00%, 100.00%, 1.00);',
        },
        main_active: {styleLess: 'background-color: #43464d;'},
      },
    },
    {
      _id: '0aedf519-3b74-1865-e2e4-926f45382757',
      type: 'class',
      name: 'Gallery Grid',
      comb: '',
      styleLess:
        'display: grid; grid-auto-columns: 1fr; grid-row-gap: 40px; grid-template-columns: 1fr; grid-template-rows: auto auto;',
      children: [],
      variants: {},
    },
    {
      _id: '8ce3839e-2a35-149b-8c70-921387a656ed',
      type: 'class',
      name: 'Gallery Image',
      comb: '',
      styleLess: 'width: 100%;',
      children: ['89b50107-cd85-1ac0-949b-4d4b42a224f4'],
      variants: {},
    },
    {
      _id: '89b50107-cd85-1ac0-949b-4d4b42a224f4',
      type: 'class',
      name: 'Shadow Two',
      comb: '&',
      styleLess: '',
      children: [],
      variants: {},
    },
  ],
} as const;
